export const FETCH_CATEGORIES = 'category/FETCH_CATEGORIES'
export const FETCH_CATEGORIES_SUCCESS = 'category/FETCH_CATEGORIES_SUCCESS'
export const FETCH_CATEGORIES_FAILURE = 'category/FETCH_CATEGORIES_FAILURE'
export const RESET_CATEGORIES = 'category/RESET_CATEGORIES'

export const FETCH_CATEGORY = 'category/FETCH_CATEGORY'
export const FETCH_CATEGORY_SUCCESS = 'category/FETCH_CATEGORY_SUCCESS'
export const FETCH_CATEGORY_FAILURE = 'category/FETCH_CATEGORY_FAILURE'
export const RESET_CATEGORY = 'category/RESET_CATEGORY'

export const CREATE_CATEGORY = 'category/CREATE_CATEGORY'
export const CREATE_CATEGORY_SUCCESS = 'category/CREATE_CATEGORY_SUCCESS'
export const CREATE_CATEGORY_FAILURE = 'category/CREATE_CATEGORY_FAILURE'
export const RESET_CREATE_CATEGORY = 'category/RESET_CREATE_CATEGORY'

export const UPDATE_CATEGORY = 'category/UPDATE_CATEGORY'
export const UPDATE_CATEGORY_SUCCESS = 'category/UPDATE_CATEGORY_SUCCESS'
export const UPDATE_CATEGORY_FAILURE = 'category/UPDATE_CATEGORY_FAILURE'
export const RESET_UPDATE_CATEGORY = 'category/RESET_UPDATE_CATEGORY'

export const DELETE_CATEGORY = 'category/DELETE_CATEGORY'
export const DELETE_CATEGORY_SUCCESS = 'category/DELETE_CATEGORY_SUCCESS'
export const DELETE_CATEGORY_FAILURE = 'category/DELETE_CATEGORY_FAILURE'
export const RESET_DELETE_CATEGORY = 'category/RESET_DELETE_CATEGORY'


// WEBPACK FOOTER //
// ./src/store/category/actionTypes.js